(()=>{
  let fullscreenOpener=null;
  const FRAME_COLORS={'Light brown':'#a57a55','Black':'#171717','White':'#f6f4ef'};
  const modal=()=>document.querySelector('[data-ja-fullscreen-modal]');
  const close=()=>{const d=modal();if(d?.open)d.close();document.documentElement.style.overflow='';};
  const applyFrame=(dialog,button)=>{
    const frame=dialog?.querySelector('[data-ja-fullscreen-frame]');
    if(!frame)return;
    const selected=(button?.dataset.frameColor||'').trim();
    dialog.classList.toggle('is-framed',Boolean(selected));
    if(selected){
      frame.style.setProperty('--ja-frame-color',FRAME_COLORS[selected]||selected);
      frame.dataset.frameColor=selected;
    }else{
      frame.style.removeProperty('--ja-frame-color');
      delete frame.dataset.frameColor;
    }
  };
  document.addEventListener('click',e=>{
    const b=e.target.closest('[data-ja-fullscreen-open]');
    if(b){
      e.preventDefault();
      fullscreenOpener=b;
      const d=modal(),i=d?.querySelector('[data-ja-fullscreen-image]'),t=d?.querySelector('[data-ja-fullscreen-title]');
      if(!d||!i)return;
      const title=b.dataset.productTitle||'';
      const frameColor=(b.dataset.frameColor||'').trim();
      i.src=b.dataset.productImage||'';
      i.alt=frameColor?`${title} with ${frameColor} frame`:title;
      if(t)t.textContent=frameColor?`${title} ${frameColor} frame`:title;
      applyFrame(d,b);
      if(!d.open)d.showModal();
      document.documentElement.style.overflow='hidden';
      return;
    }
    if(e.target.closest('[data-ja-fullscreen-close]'))close();
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape')close()});
  document.addEventListener('DOMContentLoaded',()=>{
    const d=modal();if(!d)return;
    d.addEventListener('click',e=>{if(e.target===d)close()});
    d.addEventListener('close',()=>{document.documentElement.style.overflow='';d.classList.remove('is-framed');const f=d.querySelector('[data-ja-fullscreen-frame]');if(f)f.style.removeProperty('--ja-frame-color');if(fullscreenOpener?.isConnected)fullscreenOpener.focus({preventScroll:true});fullscreenOpener=null;});
  });
})();
